import React from "react";

import { Gallery } from "../components/Gallery";

export const ClientWorkPage = () => {
  return <Gallery filter="clientwork" />;
};
